import {
  ON_REPORTS_SELECTED_CURRENCY_CHANGE,
  UPDATE_STATE_WITH_FETCHED_REPORT
} from '../actions.js';
import { SESSION_FETCH_SUCCESS } from '../../session/actions';

const initialState = '';

export default (state = initialState, action) => {
  if (action.type === SESSION_FETCH_SUCCESS) {
    // Always start with All currencies selected
    return null;
  }
  else if (action.type === ON_REPORTS_SELECTED_CURRENCY_CHANGE) {
    return action.payload;
  }
  else if (action.type == UPDATE_STATE_WITH_FETCHED_REPORT) {
    return action.payload.fetchedReport.currencyFilter;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/selected-currency.js